var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_28_99)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4286 12H52.1429C51.2754 12 50.5714 12.7024 50.5714 13.5714V19.8571C50.5714 20.7261 51.2754 21.4286 52.1429 21.4286H53.7143V26.1429H45.8571C45.8069 26.1429 45.7644 26.1664 45.7157 26.1711C43.7279 24.2131 41.0046 23 38 23C34.2396 23 30.916 24.8999 28.9313 27.7866C28.8134 27.7583 28.6987 27.7143 28.5714 27.7143H22.2857V21.4286H23.8571C24.7246 21.4286 25.4286 20.7261 25.4286 19.8571V13.5714C25.4286 12.7024 24.7246 12 23.8571 12H17.5714C16.704 12 16 12.7024 16 13.5714V19.8571C16 20.7261 16.704 21.4286 17.5714 21.4286H19.1429V29.2857C19.1429 30.1547 19.8469 30.8571 20.7143 30.8571H27.4636C27.165 31.8534 27 32.9079 27 34C27 40.0641 31.9343 45 38 45C39.0921 45 40.1466 44.835 41.1429 44.5364V49.7143H25.4286V48.1429C25.4286 47.2739 24.7246 46.5714 23.8571 46.5714H17.5714C16.704 46.5714 16 47.2739 16 48.1429V54.4286C16 55.2976 16.704 56 17.5714 56H23.8571C24.7246 56 25.4286 55.2976 25.4286 54.4286V52.8571H42.7143C43.5817 52.8571 44.2857 52.1547 44.2857 51.2857V43.4286C44.2857 43.3013 44.2417 43.1866 44.2134 43.0687C47.1001 41.084 49 37.7604 49 34C49 32.3123 48.6056 30.7173 47.9236 29.2857H55.2857C56.1531 29.2857 56.8571 28.5833 56.8571 27.7143V21.4286H58.4286C59.296 21.4286 60 20.7261 60 19.8571V13.5714C60 12.7024 59.296 12 58.4286 12ZM19.1429 15.1429H22.2857V18.2857H19.1429V15.1429ZM22.2857 52.8571H19.1429V49.7143H22.2857V52.8571ZM45.6984 32.4286H39.5714V26.3016C42.6451 26.9286 45.0714 29.3549 45.6984 32.4286ZM30.1429 34C30.1429 30.2066 32.8473 27.0323 36.4286 26.3016V33.5647L32.7074 39.7671C31.1423 38.3309 30.1429 36.2864 30.1429 34ZM35.404 41.381L38.8894 35.5714H45.6984C44.9677 39.1527 41.795 41.8571 38 41.8571C37.0854 41.8571 36.2211 41.6701 35.404 41.381ZM56.8571 18.2857H53.7143V15.1429H56.8571V18.2857Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_28_99",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_99"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_99",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.aca329350040b63db03c67ecbc206e41.svg";
export { ForwardRef as ReactComponent };